export const LOAD_PORTFOLIO = 'LOAD_PORTFOLIO';



/** WEBPACK FOOTER **
 ** ../src/dash/front/portfolio/constants.js
 **/